<template>
    <div class="card" id="card">
        <div class="card-title">
            <div class="card-title-line"></div>
            <div class="title-left">
                {{ title }}
            </div>
        </div>
        <div class="card-row" v-for="item in list" :key="item.key">
            <div class="card-row-label">{{ item.label }}</div>
            <div class="card-row-value">
                {{ item.value }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Card',
    props: {
        title: {
            type: String,
            require: true
        },
        list: {
            type: Array,
            require: true
        }
    }
};
</script>

<style lang="less" scoped>
.card {
    font-size: 12px;
    color: #333333;
    .card-title {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 600;
    }
    .card-title-line {
        width: 3px;
        height: 12px;
        background: #4285f5;
        margin-right: 8px;
    }
    .card-row {
        margin-top: 12px;
        display: flex;
    }
    .card-row-label {
        flex-shrink: 0;
        color: #888888;
    }
    .card-row-value {
        flex: 1;
        min-width: 0;
        margin-right: 20px;
        word-wrap: break-word;
        word-break: normal;
    }
}
</style>
